"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeRequest = void 0;
var CodeRequest = /** @class */ (function () {
    function CodeRequest() {
    }
    return CodeRequest;
}());
exports.CodeRequest = CodeRequest;
;
//# sourceMappingURL=code.request.js.map